import { render, staticRenderFns } from "./noLayout.vue?vue&type=template&id=08c9d604&scoped=true&"
import script from "./noLayout.vue?vue&type=script&lang=js&"
export * from "./noLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c9d604",
  null
  
)

export default component.exports